import axios from "axios";
import { createContext, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
// use API instance for intercepted responses
// import { baseURL } from "../../services/api";
import { API, baseURL } from "../../services/api";
import {
  ALL_ACCESS_ROLE_ID,
  COMMERCIAL_ROLE_ID,
  COMPTABLE_ROLE_ID,
  PACK_BASIC_MEMBERS,
  PACK_BASIC_ORGS,
  PACK_PREMIUM_MEMBERS,
  PACK_PREMIUM_ORGS,
  PACK_STANDARD_MEMBERS,
  PACK_STANDARD_ORGS,
} from "../../helpers/constants";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    if (localStorage.getItem("tokens")) {
      let tokens = JSON.parse(localStorage.getItem("tokens"));
      //return jwt_decode(tokens.access_token);
      if (tokens.user.parent_id === 0) {
        tokens.user.id_sousUser = tokens.user.id;
        return {...tokens.user, id_sousUser: tokens.user.id_sousUser};//ajouter le  id_sousUser
      } else {
        //override user.id to be equal parent_id
        tokens.user.id_sousUser = tokens.user.id;
        tokens.user.id = tokens.user.parent_id;
        return {...tokens.user, id_sousUser: tokens.user.id_sousUser};//ajouter le  id_sousUser
      }
    }
    return null;
  });
  const [userAcces, setUserAcces] = useState(() => {
    if (localStorage.getItem("tokens")) {
      let tokens = JSON.parse(localStorage.getItem("tokens"));
      if (tokens.userAccess) {
        return tokens.userAccess;
      } else {
        return {
          had_add_access: 0,
          had_edit_access: 0,
          had_delete_access: 0,
        };
      }
    }
    return {
      had_add_access: 0,
      had_edit_access: 0,
      had_delete_access: 0,
    };
  }
  );

  const [isAdmin, setIsAdmin] = useState(() => {
    console.log("******************");
    console.log("******************");
    console.log("******************");
    console.log("******************");
    console.log("user: ", user);
    if (user != null) {
      return user.parent_id === 0;
    }
    return false;
  });

  const [isComptable, setIsComptable] = useState(() => {
    if (user != null) {
      return user.role === COMPTABLE_ROLE_ID && user.parent_id !== 0;
    }
    return false;
  });

  const [maxOrgs, setMaxOrgs] = useState(() => {
    if (user != null && user.package_id != null) {
      if (user.package_id === 1) {
        return PACK_BASIC_ORGS;
      } else if (user.package_id === 2) {
        return PACK_STANDARD_ORGS;
      } else if (user.package_id === 3) {
        return PACK_PREMIUM_ORGS;
      }
    }
  });

  const [maxTeamMembers, setMaxTeamMembers] = useState(() => {
    if (user != null && user.package_id != null) {
      if (user.package_id === 1) {
        return PACK_BASIC_MEMBERS;
      } else if (user.package_id === 2) {
        return PACK_STANDARD_MEMBERS;
      } else if (user.package_id === 3) {
        return PACK_PREMIUM_MEMBERS;
      }
    }
  });

  const [isCommercial, setIsCommercial] = useState(() => {
    if (user != null) {
      return user.role === COMMERCIAL_ROLE_ID && user.parent_id !== 0;
    }
    return false;
  });
  const [hadAddAccess, setHadAddAccess] = useState(() => {
    if (user != null) {
      return user.role === COMMERCIAL_ROLE_ID && userAcces.had_add_access !== 0;
    }
    return false;
  });
  const [hadEditAccess, setHadEditAccess] = useState(() => {
    if (user != null) {
      return user.role === COMMERCIAL_ROLE_ID && userAcces.had_edit_access !== 0;
    }
    return false;
  });
  const [hadDeleteAccess, setHadDeleteAccess] = useState(() => {
    if (user != null) {
      return user.role === COMMERCIAL_ROLE_ID && userAcces.had_delete_access !== 0;
    }
    return false;
  });

  const [isComptableAndCommercial, setIsComptableAndCommercial] = useState(
    () => {
      if (user != null) {
        return user.role === ALL_ACCESS_ROLE_ID && user.parent_id !== 0;
      }
      return false;
    }
  );

  const updateUser = (_user) => {
    setUser(_user);
  };

  const navigate = useNavigate();

  const login = async (payload) => {
    try {
    
// Maintenance mode: login request uses API interceptor

      // const apiResponse = await axios.post(`${baseURL}/auth/login`, payload, {
      const apiResponse = await API.post(`/auth/login`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  const checkEmail = async (payload) => {
    try {
      const apiResponse = await axios.post(
        `${baseURL}/auth/password/email`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  const checkCode = async (payload) => {
    try {
      const apiResponse = await axios.post(
        `${baseURL}/auth/password/code/check`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  const setNewPassword = async (payload) => {
    try {
      const apiResponse = await axios.post(
        `${baseURL}/auth/password/reset`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  const register = async (payload) => {
    try {
      const apiResponse = await axios.post(
        `${baseURL}/auth/register`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    // invoke the logout API call, for our NestJS API no logout API 

    localStorage.removeItem("tokens");
    localStorage.removeItem("orgs");
    setUser(null);
    window.location.reload();
    //navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{
        maxOrgs,
        maxTeamMembers,
        isComptable,
        isCommercial,
        isComptableAndCommercial,
        isAdmin,
        hadAddAccess,
        hadEditAccess,
        hadDeleteAccess,
        userAcces,
        setUserAcces,
        user,
        setUser,
        updateUser,
        login,
        register,
        logout,
        checkEmail,
        checkCode,
        setNewPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
